export const BUGSNAG_API_KEY = `${process.env.REACT_APP_BUGSNAG_API_KEY}`;
export const RELEASE_STAGE = `${process.env.REACT_APP_RELEASE_STAGE}`;
export const GRAPHQL_ENDPOINT = `${process.env.REACT_APP_GRAPHQL_ENDPOINT}`;
export const GOOGLE_API = `${process.env.REACT_APP_GOOGLE_API_KEY}`;
// export const WEBPUSH_PUBLIC_VAPID_KEY = `${process.env.REACT_APP_WEBPUSH_PUBLIC_VAPID_KEY}`;

export const NETWORK_FAILED_TO_FETCH = 'Failed to fetch';

// Local
export const JWT_COOKIE_KEY = 'IMPACTBOARD_JWT';
export const KEYBOARD_CODE = {
  ENTER: 13,
};

// Indexed DB Consts
export const ALL_INSTITUTION_TYPES_PREFIX = 'AllInstitutionTypes';
export const ALL_MINISTRIES_PREFIX = 'AllMinistries';
export const ALL_COUNTRIES_PREFIX = 'AllCountries';
export const ALL_PROVINCES_PREFIX = 'AllProvinces';
export const ALL_DISTRICTS_PREFIX = 'AllDistricts';
export const ALL_INSTITUTION_PORTAL_USERS = 'AllInstitutionPortalUsers';
export const ALL_DISTRICT_MUNICIPALITIES_PREFIX = 'AllDistrictMunicipalities';
export const ALL_LOCAL_MUNICIPALITIES_PREFIX = 'AllLocalMunicipalities';
export const ECD_REG_TYPE_PREFIX = 'ECDRegistration_';
export const ECD_REQ_DOC_PREFIX = 'ECDRequiredDocument_';
export const INSTITUTION_PREFIX = 'Institution_';
export const NON_CENTER_BASED_SURVEY_KEY = 'Survey_NCB';
export const PARTIAL_CARE_FACILITY_SURVEY_KEY = 'Survey_PCF';
export const USER_ID_PREFIX = 'UserID_';
export const USER_PREFIX = 'User_';
export const PORTAL_ORGANISATION_PREFIX = 'PortalOrganisation_';
export const ALL_ECD_REGISTRATION_TYPES = 'AllECDRegistrationTypes';
export const ALL_PEOPLE_PREFIX = 'AllPeople';
export const PERSON_PREFIX = 'Person_';
export const NOTIFICATION_PREFIX = 'Notification_';
export const ALL_NATIONALITIES_PREFIX = 'AllNationalities';
export const ALL_GENDERS_PREFIX = 'AllGenders';
export const ALL_POPULATION_GROUPS_PREFIX = 'AllPopulationGroups';
export const ALL_HOME_LANGUAGES_PREFIX = 'AllHomeLanguages';
export const ALL_DISABILITY_TYPES_PREFIX = 'AllDisabilityTypes';
export const ALL_PEOPLE_TYPES_PREFIX = 'AllPeopleTypes';
export const ALL_GRADES_PREFIX = 'AllGrades';

export {
  GRANULARITY,
  ACTIVITY_STATS_LEVELS,
  DETAILED_INSTITUTION_STATS,
  DETAILED_INTERVENTION_STATS,
  DETAILED_PROGRAMME_STATS,
  DETAILED_SP_STATS,
  DETAILED_STAKEHOLDER_COMMUNITY_MEMBER_STATS,
  DETAILED_STAKEHOLDER_DISTRICT_OFFICIALS_STATS,
  DETAILED_STAKEHOLDER_LEARNERS_STATS,
  DETAILED_STAKEHOLDER_PROVINCIAL_OFFICIALS_STATS,
  DETAILED_STAKEHOLDER_SCHOOL_OFFICIALS_STATS,
  OVERALL_INTERVENTION_STATS,
  OVERALL_PROGRAMME_STATS,
  OVERALL_SP_STATS,
  OVERALL_INSTITUTION_STATS,
  OVERALL_STAKEHOLDER_COMMUNITY_MEMBER_STATS,
  OVERALL_STAKEHOLDER_DISTRICT_OFFICIALS_STATS,
  OVERALL_STAKEHOLDER_LEARNERS_STATS,
  OVERALL_STAKEHOLDER_PROVINCIAL_OFFICIALS_STATS,
  OVERALL_STAKEHOLDER_SCHOOL_OFFICIALS_STATS,
  activityStatsVisibleOptions,
  activityStatsSelectOptions,
} from './exports/activityProgrammeStats';
export { INPUT_STATS_LEVELS, inputStatsSelectOptions, inputStatsVisibleOptions } from './exports/inputProgrammeStats';
export { institutionPortalExportHeaders, institutionPortalExportHeadersMasterList } from './exports/institutions';
export { userReportExportHeaders } from './exports/userReport';
export {
  baseHeader,
  testPerformanceExportBaseColumn,
  schoolSubjectReportExportBaseColumn,
  NSCProgressionExportBaseColumn,
  NSCSubjectExportBaseColumn,
  schoolAttendanceBaseColumn,
  schoolPromotionBaseColumn,
  schoolEducatorBaseColumn,
  schoolEnrolmentBaseColumn,
  onlyInterventionHeader,
  onlyProgrammeHeader,
  onlyServiceProviderHeader,
} from './exports/schoolData';
export { institutionHeaders, interventionHeaders, stakeholdersHeaders } from './exports/profileData';
export {
  COMMUNITY_MEMBER_STAKEHOLDER_TEMPLATE,
  DISTRICT_OFFICIALS_STAKEHOLDER_TEMPLATE,
  SOCIAL_SERVICES_PROFESSIONAL_STAKEHOLDER_TEMPLATE,
  EDUCATOR_ATTENDANCE_TEMPLATE,
  FUNDER_TEMPLATE,
  INSTITUTION_TEMPLATE,
  LEARNERS_STAKEHOLDER_TEMPLATE,
  NSC_PROGRESSION_TEMPLATE,
  NSC_SUBJECT_TEMPLATE,
  PROVINCIAL_OFFICIALS_STAKEHOLDER_TEMPLATE,
  SCHOOL_ATTENDANCE_TEMPLATE,
  SCHOOL_ENROLMENT_TEMPLATE,
  SCHOOL_OFFICIALS_STAKEHOLDER_TEMPLATE,
  NATIONAL_OFFICIALS_STAKEHOLDER_TEMPLATE,
  SCHOOL_PROGRESSION_TEMPLATE,
  SCHOOL_PROMOTION_TEMPLATE,
  SCHOOL_SUBJECT_TEMPLATE,
  SCHOOL_TEST_TEMPLATE,
  SERVICE_PROVIDER_TEMPLATE,
  TEAM_MEMBER_TEMPLATE,
  TEST_PERFORMANCE_TEMPLATE,
  MULTIPLE_INSTITUTIONS,
  COMMON_ASSOCIATE_PEOPLE_TO_SP_TEMPLATE,
  LEARNERS_ASSOCIATE_PEOPLE_TO_SP_TEMPLATE,
  STUDENT_STAKEHOLDER_TEMPLATE,
} from './uploadTemplates';
export {
  GEOGRAPHY_LEVEL_OPTIONS,
  PROGRAMME_INITIAL_VALUES,
  PROGRAMME_OVERVIEW_ISARCHIVED_OPTIONS,
  programmeSteps,
} from './programme';
export { ecdServiceSteps, ECD_INITIAL_VALUES } from './ecdService';

export const insightsLink = {
  'http://localhost:4000':
    'https://datastudio.google.com/embed/reporting/e9faa222-94a7-41d7-8554-9dddffc36837/page/4lydB',
  'https://dev-api.impactboard.tech':
    'https://datastudio.google.com/embed/reporting/e9faa222-94a7-41d7-8554-9dddffc36837/page/4lydB',
  'https://uat-api.impactboard.tech': '',
  'https://prod-api.impactboard.tech': '',
}[GRAPHQL_ENDPOINT];
